import { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import { useEmbedCrm } from 'utils/embedSession/useEmbedCrm'
import { useTranslation } from 'react-i18next'

export const EmbedPropertyError: FC = () => {
  const { t } = useTranslation(['embed'])
  const { crmName } = useEmbedCrm()

  return (
    <Stack spacing={1} alignItems='center' justifyContent='center' sx={{ height: '100%', p: 4, textAlign: 'center' }}>
      <Typography variant='h6'>{t('property_error.title')}</Typography>
      <Typography variant='body2' color='text.secondary'>{t('property_error.message_crm', { crm: crmName })}</Typography>
    </Stack>
  )
}

export default EmbedPropertyError
